/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkInstitutePersonRequest
 */
export interface LinkInstitutePersonRequest {
    /**
     * the unique identifier of the institute
     * @type {string}
     * @memberof LinkInstitutePersonRequest
     */
    instituteId?: string;
    /**
     * true if the should have the ADMIN_INSTITUTE permission
     * @type {boolean}
     * @memberof LinkInstitutePersonRequest
     */
    addRoleAdmin?: boolean;
}

/**
 * Check if a given object implements the LinkInstitutePersonRequest interface.
 */
export function instanceOfLinkInstitutePersonRequest(value: object): value is LinkInstitutePersonRequest {
    return true;
}

export function LinkInstitutePersonRequestFromJSON(json: any): LinkInstitutePersonRequest {
    return LinkInstitutePersonRequestFromJSONTyped(json, false);
}

export function LinkInstitutePersonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkInstitutePersonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'instituteId': json['instituteId'] == null ? undefined : json['instituteId'],
        'addRoleAdmin': json['addRoleAdmin'] == null ? undefined : json['addRoleAdmin'],
    };
}

export function LinkInstitutePersonRequestToJSON(json: any): LinkInstitutePersonRequest {
    return LinkInstitutePersonRequestToJSONTyped(json, false);
}

export function LinkInstitutePersonRequestToJSONTyped(value?: LinkInstitutePersonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instituteId': value['instituteId'],
        'addRoleAdmin': value['addRoleAdmin'],
    };
}

